import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  facesList: [],
  page: 0,
  lastPage: 0,
  totalCount: 0,
  loadedPages: [],
  lastVisibleIndex: 0,
  sortKey: null,
  sortOrder: null,
  requestId: null,
  searchValue: "",
};
const facesPageSlice = createSlice({
  name: "facePage",
  initialState,
  reducers: {
    setFaces: (state, action) => {
      const { data, page, lastPage, count } = action.payload;
      state.lastPage = lastPage;
      state.totalCount = count;
      state.page = page;
      // ✅ avoid duplicate append
      if (!state.loadedPages.includes(page)) {
        if (page === 0) {
          state.facesList = data;
        } else {
          state.facesList = [...state.facesList, ...data];
        }

        state.loadedPages.push(page);
      }
    },

    incrementFacesPage: (state) => {
      state.page += 1;
    },

    setFacesPageLastVisibleIndex: (state, action) => {
      const index = action.payload;
      state.lastVisibleIndex = index;
    },
    setFacesPageSort: (state, action) => {
      const { sortKey, sortOrder } = action.payload;
      state.sortKey = sortKey;
      state.sortOrder = sortOrder;
      // reset everything when sort changes
      state.facesList = [];
      state.page = 0;
      state.lastPage = 0;
      state.totalCount = 0;
      state.loadedPages = [];
      state.lastVisibleIndex = 0;
      state.searchValue = "";
    },
    facesPageRequestIdSearch: (state, action) => {
      const requestId = action.payload;
      state.requestId = requestId;
      // reset everything when requestId changes
      state.facesList = [];
      state.page = 0;
      state.lastPage = 0;
      state.totalCount = 0;
      state.loadedPages = [];
      state.lastVisibleIndex = 0;
      state.sortKey = null;
      state.sortOrder = null;
      state.searchValue = "";
    },
    facesPageNameSearch: (state, action) => {
      const searchValue = action.payload;
      state.searchValue = searchValue;
      // reset everything when searchValue changes
      state.facesList = [];
      state.page = 0;
      state.lastPage = 0;
      state.totalCount = 0;
      state.loadedPages = [];
      state.lastVisibleIndex = 0;
      state.sortKey = null;
      state.sortOrder = null;
      state.requestId = null;
    },
    setFacesPageDataClear: (state, action) => {
      state.facesList = [];
      state.page = 0;
      state.lastPage = 0;
      state.totalCount = 0;
      state.loadedPages = [];
      state.lastVisibleIndex = 0;
      state.sortKey = null;
      state.sortOrder = null;
      state.searchValue = "";
      state.requestId = null;
    },
  },
});

export const {
  setFaces,
  incrementFacesPage,
  setFacesPageLastVisibleIndex,
  setFacesPageSort,
  setFacesPageDataClear,
  facesPageRequestIdSearch,
  facesPageNameSearch,
} = facesPageSlice.actions;
export default facesPageSlice;
